var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'height':_vm.height,'width':'100%'}),attrs:{"id":"container","tabindex":"0"}},[_c('el-amap',{staticClass:"amap-box",attrs:{"center":_vm.center,"expandZoomRange":"true","zoom":_vm.zoom}},[_c('el-amap-marker',{attrs:{"position":_vm.center}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }